<template>
    <div>
        <el-dialog
            :visible.sync="addressInfo.dialog"
            :title="'แก้ไข' + addressInfo.data.mode.name"
            :show-close = false
            width="30%"
        >
            <el-input v-model="inputInfo" type="text" :maxlength="wordSize" show-word-limit></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogStatus">Cancel</el-button>
                <el-button :disabled="zipcodeActiveStatus" type="primary" @click="confirmEdit" >Confirm</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import fgApi from '@/services/fillgoods'
export default {
    name: 'ZipcodeSystemDialog',
    props: {
        addressInfo: {
            type: Object,
            default: () => {
                return {
                    dialog: false,
                    data: {
                        propName: '',
                        zipcodeId: null,
                        provinceId: null,
                        districtId: null,
                        subDistrictId: null,
                        mode: {
                            name: '',
                            key: null
                        }
                    }
                }
            }
        }
    },
    data () {
        return {
            wordSize: null,
            inputInfo: '',
            zipcodeActiveStatus: false,
            zipcodeStateChange: ''
        }
    },
    computed: {
        activeZipcodeEdit () {
            return this.addressInfo.data.mode.key === 0
        },
        activeProvinceEdit () {
            return this.addressInfo.data.mode.key === 1
        },
        activeDistrictEdit () {
            return this.addressInfo.data.mode.key === 2
        },
        activeSubDistrictEdit () {
            return this.addressInfo.data.mode.key === 3
        }
    },
    watch: {
        'addressInfo.dialog' (val) {
            console.log(val)
            if (val) {
                this.inputInfo = this.addressInfo.data.propName
                this.zipcodeStateChange = this.addressInfo.data.mode.key
            }
        },
        inputInfo (val) {
            console.log('length', this.zipcodeStateChange, val.length)
            if (val) {
                if (this.activeZipcodeEdit && val.match(/^[\d\s]+$/g)) {
                    this.wordSize = 5
                    this.inputInfo = val
                    if (val.length < 5) {
                        console.log('hide')
                        this.zipcodeActiveStatus = true
                    } else {
                        console.log('show')
                        this.zipcodeActiveStatus = false
                    }
                } else if (this.activeProvinceEdit && val.match(/^[ก-์]+$/ig)) {
                    this.wordSize = 40
                    this.inputInfo = val
                    this.zipcodeActiveStatus = false
                } else if (this.activeDistrictEdit && val.match(/^[ก-์]+$/ig)) {
                    this.wordSize = 40
                    this.inputInfo = val
                    this.zipcodeActiveStatus = false
                } else if (this.activeSubDistrictEdit && val.match(/^[ก-์]+$/ig)) {
                    this.wordSize = 40
                    this.inputInfo = val
                    this.zipcodeActiveStatus = false
                } else {
                    this.inputInfo = ''
                    this.zipcodeActiveStatus = false
                }
            } else {
                this.zipcodeActiveStatus = true
            }
        }
    },
    methods: {
        dialogStatus () {
            this.addressInfo.dialog = false
        },
        async editAddress (val) {
            try {
                console.log('check val', val)
                switch (val) {
                case 0:
                    console.log(this.inputInfo, this.addressInfo.data.zipcodeId)
                    let paramZip = {
                        zipcode_id: this.addressInfo.data.zipcodeId,
                        detail: this.inputInfo
                    }
                    console.log('--------', paramZip)
                    let resZip = await fgApi.order.updateZipcode(paramZip)
                    console.log(resZip)
                    if (resZip.success) {
                        console.log('Success')
                        this.$message.success('Update success!')
                        this.$emit('refeshInfo', val)
                    } else {
                        console.log('fialed')
                        this.$message.error('Update fialed!')
                        this.$emit('refeshInfo', val)
                    }
                    break
                case 1:
                    console.log(this.inputInfo)
                    let paramProv = {
                        province_id: this.addressInfo.data.provinceId,
                        province_name: this.inputInfo
                    }
                    console.log('--------', paramProv)
                    let resProv = await fgApi.order.updateProvince(paramProv)
                    console.log(resProv)
                    if (resProv.success) {
                        console.log('Success')
                        this.$message.success('Update success!')
                        this.$emit('refeshInfo', val)
                    } else {
                        console.log('fialed')
                        this.$message.error('Update fialed!')
                        this.$emit('refeshInfo', val)
                    }
                    break
                case 2:
                    let paramDist = {
                        district_name: this.inputInfo,
                        district_id: this.addressInfo.data.districtId
                    }
                    console.log('--------', paramDist)
                    let resDist = await fgApi.order.updateDistrict(paramDist)
                    console.log(resDist)
                    if (resDist.success) {
                        console.log('Success')
                        this.$message.success('Update success!')
                        this.$emit('refeshInfo', val)
                    } else {
                        console.log('fialed')
                        this.$message.error('Update fialed!')
                        this.$emit('refeshInfo', val)
                    }
                    break
                case 3:
                    let paramSubDist = {
                        sub_district_name: this.inputInfo,
                        sub_district_id: this.addressInfo.data.subDistrictId
                    }
                    console.log('--------', paramSubDist)
                    let resSubDist = await fgApi.order.updateSubDistrict(paramSubDist)
                    console.log(resSubDist)
                    if (resSubDist.success) {
                        console.log('Success')
                        this.$message.success('Update success!')
                        this.$emit('refeshInfo', val)
                    } else {
                        console.log('fialed')
                        this.$message.error('Update fialed!')
                        this.$emit('refeshInfo', val)
                    }
                    break
                default:
                    console.log('Sorry, we are out of ' + val + '.')
                }
            } catch (error) {
                this.$message.error('Oops, Api is error !')
            }
        },
        confirmEdit () {
            this.dialogStatus()
            this.$confirm('Are you sure to edit ?', 'Warning', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.editAddress(this.addressInfo.data.mode.key)
                this.$message({
                    type: 'success',
                    message: 'Edit Success'
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Edit Canceled'
                })
            })
        }
    }
}
</script>
